export default "__VITE_ASSET__PMPzRKCy__"